export const getZoomFromLocalStorage = () => {
  return window.localStorage.getItem('zoom') ? parseFloat(window.localStorage.getItem('zoom')) : 1;
};